module.exports = function () {
    var userAgent = ICF.Utils.GetUserAgent();
    return /blackberry/.test(userAgent) || /bb10/.test(userAgent);
};